module.exports = __webpack_public_path__ + "assets/images/carSeat-03.d151a9ff13967f1c35779919dcf5418f.svg";